import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { appendAlertItem, AlertType } from '@pruforce/common-adminweb-sdk';
import { StepStatusEnum, ComponentProps } from 'src/app/common/components/pru-stepped-form';
import { EventFormCommonProps } from 'src/app/modules/event-v2/types';
import { CreateUpdateEventBody, modifyEventItem } from 'src/app/modules/event-v2/network';

type HookProps = ComponentProps<EventFormCommonProps>;

export const useWalkInForm = ({ formCommonProps, onStepChange }: HookProps) => {
  const dispatch = useDispatch();
  const { eventItem, reloadData } = formCommonProps;
  const walkInFormRef = useRef<any>();

  const handleSave = () => {
    if (walkInFormRef.current) {
      walkInFormRef.current?.handleSave();
    }
  };

  const onSubmit = async (data: any) => {
    const body: CreateUpdateEventBody = {
      walkInFormBody: data.content,
    };
    try {
      if (eventItem) {
        await modifyEventItem(eventItem._id, body, dispatch);
        await reloadData();
        dispatch(
          appendAlertItem([
            {
              severity: AlertType.SUCCESS,
              title: 'Success',
              content: 'Data saved successfully',
            },
          ]),
        );
        onStepChange({
          newActiveStep: { stepIndex: 0, child: { stepIndex: 5 } },
          currentStepStatus: StepStatusEnum.FINISHED,
          forceNavigation: true,
          saveChanges: true,
        });
      }
    } catch (err) {}
  };

  return {
    walkInFormRef,
    handleSave,
    onSubmit,
  };
};
